export default __webpack_public_path__ + "static/media/web-letters.d65761b4.svg";